// Comma-separated key paths input for validate_required's `fields[]`.
// Wraps KeyPathInput by editing only the LAST segment of the CSV —
// typing 'order_id, ' positions the cursor at a fresh path slot, the
// dropdown suggests against an empty query, and clicking a suggestion
// appends it without losing earlier entries.
//
// Extracted from pages/SourceDetailPage.tsx as part of the file split
// (Apr 2026).

import KeyPathInput from '../KeyPathInput';

export function ValidateFieldsInput({ value, onChange, sourceId }: { value: string; onChange: (v: string) => void; sourceId: string }) {
  const parts = value.split(',');
  const last = parts[parts.length - 1] ?? '';
  const lead = parts.slice(0, -1).join(',');
  function onPathChange(next: string): void {
    onChange(lead ? `${lead},${last.startsWith(' ') ? ' ' : ''}${next}` : next);
  }
  return (
    <KeyPathInput
      value={last.trimStart()}
      onChange={onPathChange}
      sourceId={sourceId}
      placeholder="customer.email, amount, order.id"
    />
  );
}
